import { defaultHttpClient } from '../../httpClient';
import type {
  GetMarketParentHomeGoodsRequestParams,
  GetMarketParentHomeGoodsResponse,
} from './types';

export const getMarketParentHomeGoods = (
  marketId: number,
  params: GetMarketParentHomeGoodsRequestParams,
) => {
  return defaultHttpClient
    .request<GetMarketParentHomeGoodsResponse>({
      url: `/api/v2/markets/${marketId}/parent/home-goods/`,
      method: 'GET',
      params,
    })
    .then(result => result.data);
};
